// Small helpers for consistent SEO URLs across SPA + prerender builds.

export function readEnvCra(key, fallback = '') {
  const env = typeof process !== 'undefined' && process?.env ? process.env : {};
  return String(env[key] || fallback || '');
}

export function ensureAbsUrl(url) {
  if (!url) return '';
  try {
    return new URL(url, typeof window !== 'undefined' ? window.location.origin : 'http://localhost').toString();
  } catch {
    return '';
  }
}

function isLocalHost(hostname = '') {
  const h = String(hostname).toLowerCase();
  return (
    h === 'localhost' ||
    h === '127.0.0.1' ||
    h === '0.0.0.0' ||
    h.endsWith('.local')
  );
}

/**
 * Normalize a canonical origin for SEO.
 *
 * Why: prerender tools (react-snap / puppeteer) often run on http://localhost:* and
 * if we blindly use window.location or an env that still points to localhost, we end up
 * shipping canonical/og:url as localhost.
 */
export function normalizeSiteOrigin(origin, { fallback = 'https://burosoul.ru' } = {}) {
  const raw = String(origin || '').trim();
  if (!raw) return fallback;

  // ensure absolute
  let abs = '';
  try {
    abs = new URL(raw, 'https://example.com').toString();
  } catch {
    abs = raw;
  }

  try {
    const u = new URL(abs);
    const isProd = readEnvCra('NODE_ENV', 'production') === 'production';
    if (isProd && isLocalHost(u.hostname)) return fallback;
    return u.origin;
  } catch {
    return fallback;
  }
}

export function getSiteOrigin() {
  const fromEnv = readEnvCra('REACT_APP_SITE_URL', '').trim();
  const fromWindow = typeof window !== 'undefined' ? window.location.origin : '';
  // prefer env, but never allow localhost in production (common prerender pitfall)
  const candidate = fromEnv || fromWindow;
  return normalizeSiteOrigin(candidate);
}

export function joinUrl(origin, path) {
  if (!origin) return '';
  try {
    return new URL(path, origin).toString();
  } catch {
    return '';
  }
}
